import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter } from "react-router";
import { App } from "./app/App.tsx";
import { createQueryClient } from "./app/queryClient.ts";
import { routes } from "./app/routes.tsx";
import { registerServiceWorker } from "./serviceWorker/register.ts";
import { reportError } from "./shared/api/errors.ts";
import { config } from "./shared/config.ts";
import { createFileUploader } from "./shared/media/fileUploader.ts";
import { createImageCompressor } from "./shared/media/imageCompressor.ts";
import { createQrSource } from "./shared/qr/qrSource.ts";
import { createTelegramLogin } from "./shared/telegram/telegramLogin.ts";

// Ошибки вне TanStack Query тоже идут в глобальный обработчик.
window.addEventListener("error", (event) => reportError(event.error));
window.addEventListener("unhandledrejection", (event) => reportError(event.reason));

const container = document.getElementById("root");
if (!container) throw new Error("Root element #root not found");

const environment = {
  // Пустой BUN_PUBLIC_API_BASE_URL — API на том же origin (в dev через прокси scripts/dev.ts).
  apiBaseUrl: config.apiBaseUrl || window.location.origin,
  fetch: (request: Request) => window.fetch(request),
  WebSocket: window.WebSocket,
  telegramLogin: config.telegramBotId ? createTelegramLogin(config.telegramBotId) : null,
  qrSource: createQrSource(),
  imageCompressor: createImageCompressor(),
  uploadFile: createFileUploader(),
  timers: {
    setTimeout: (callback: () => void, ms: number) => window.setTimeout(callback, ms),
    clearTimeout: (id: number | undefined) => window.clearTimeout(id),
  },
  share: typeof navigator.share === "function" ? (data: ShareData) => navigator.share(data) : null,
  copyText: (text: string) => navigator.clipboard.writeText(text),
};

createRoot(container).render(
  <StrictMode>
    <App environment={environment} router={createBrowserRouter(routes)} queryClient={createQueryClient()} />
  </StrictMode>,
);

// В dev worker не нужен: он бы кэшировал бандл, который пересобирается после каждой правки.
if (process.env.NODE_ENV === "production") registerServiceWorker();
